import { types } from "../types/types";

const initialState = {
  loading: false,
  dashboard: {
    total: 0,
    published: 0,
    inTray: 0,
    traysWithLoad: 0,
    byState: [],
    byTray: [],
    byUser: [],
    byModule: []
  },
  cases: [],
  total: 0,
  page: 0,
  size: 20,
  aggregates: {
    total: 0,
    published: 0,
    inTray: 0,
    traysWithLoad: 0,
    modulesWithResults: 0,
    usersWithCases: 0,
    pending: 0
  },
  detail: null
};

export const flowCmiReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FLOW_CMI_SET_LOADING:
      return { ...state, loading: action.payload };
    case types.FLOW_CMI_SET_DASHBOARD:
      return { ...state, dashboard: action.payload };
    case types.FLOW_CMI_SET_CASES:
      return {
        ...state,
        cases: action.payload.cases,
        total: action.payload.total,
        page: action.payload.page,
        size: action.payload.size,
        aggregates: action.payload.aggregates || state.aggregates
      };
    case types.FLOW_CMI_SET_DETAIL:
      return { ...state, detail: action.payload };
    case types.FLOW_CMI_CLEAR_DETAIL:
      return { ...state, detail: null };
    default:
      return state;
  }
};
